/* =====================================================================
   DEMO / MOCK DATA — NOT PRODUCTION
   Payment METHODS shown in the checkout UI as a frontend prototype only.
   There is NO settlement, NO card capture, NO PCI handling anywhere.
   The real Saudi payment provider + settlement is a future adapter contract.
   ===================================================================== */

export const PAYMENT_METHODS = [
  { id: 'mada',     name: { ar: 'مدى', en: 'mada' }, marks: ['mada'] },
  { id: 'card',     name: { ar: 'بطاقة (فيزا / ماستركارد)', en: 'Card (Visa / Mastercard)' }, marks: ['VISA', 'MC'] },
  { id: 'applepay', name: { ar: 'Apple Pay', en: 'Apple Pay' }, marks: ['Pay'] },
  { id: 'tabby',    name: { ar: 'تابي — قسّمها على ٤', en: 'Tabby — split in 4' }, marks: ['tabby'] },
  { id: 'tamara',   name: { ar: 'تمارا — ادفع لاحقاً', en: 'Tamara — pay later' }, marks: ['tamara'] },
  { id: 'salon',    name: { ar: 'الدفع في الصالون', en: 'Pay at the salon' }, marks: [] },
];
